import React from 'react';

/**
 * Catches any uncaught render/runtime error and shows a friendly recovery UI
 * instead of leaving the user on a blank white screen (common on iOS Safari
 * when a WebRTC / render error bubbles up without a boundary).
 */
export class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, message: '' };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, message: error?.message || 'Error inesperado' };
  }

  componentDidCatch(error, info) {
    // Keep a console trace for debugging on the device (Safari Web Inspector).
    console.error('Carbi ErrorBoundary caught:', error, info);
  }

  handleReload = () => {
    this.setState({ hasError: false, message: '' });
    window.location.reload();
  };

  render() {
    if (this.state.hasError) {
      return (
        <div
          className="min-h-dvh bg-background flex items-center justify-center p-6"
          data-testid="error-boundary"
        >
          <div className="w-full max-w-sm text-center">
            <h1
              className="text-2xl font-bold text-primary tracking-tight"
              style={{ fontFamily: "'Space Grotesk', sans-serif" }}
            >
              Carbi
            </h1>
            <p className="mt-4 text-base font-semibold text-foreground">
              Algo salió mal
            </p>
            <p className="mt-2 text-sm text-muted-foreground">
              Hubo un problema al cargar esta pantalla. Vuelve a intentarlo.
            </p>
            <button
              onClick={this.handleReload}
              data-testid="error-boundary-reload"
              className="mt-6 w-full h-12 rounded-xl bg-primary text-primary-foreground text-base font-semibold active:opacity-90 transition-opacity"
            >
              Recargar la aplicación
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
